import { createApp } from 'vue';
import VideoWidgetVue from './video-widget.vue';
import TooltipDirective from '../tooltip_vue';

export class VideoWidget {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(VideoWidgetVue);
        _.forEach(this.props, (value, key) => app.provide(key, value));
        app.directive('tooltip', TooltipDirective);
        app.mount(el);
    }
}